<template>
    <card class="spaced typo">
        
        <h2 class="text-white mb-4">
            {{ $t('common.logs') }}
        </h2>

        <context-filters></context-filters>

        <form @submit.prevent @keydown="filters.errors.clear($event.target.name)">

            <div class="form-row">

                <base-select class="col-lg-4 mb-2"
                    :placeholder="$t('xapi.log.api')"
                    v-model="filters.api"
                    :options="filters.options.api"
                    clearable>
                </base-select>

                <base-select class="col-lg-4 mb-2"
                    :placeholder="$t('xapi.log.method')"
                    v-model="filters.method"
                    :options="filters.options.method"
                    clearable>
                </base-select>

                <base-select class="col-lg-4 mb-2"
                    :placeholder="$t('xapi.log.status')"
                    v-model="filters.status"
                    :options="filters.options.status"
                    clearable>
                </base-select>
            </div>

            <div class="text-center pt-1">
                <base-button type="primary" native-type="submit" @click="apply">
                    {{ $t('common.apply') }}
                </base-button>

                <base-button type="primary" native-type="submit" link @click="reset">
                    {{ $t('common.reset') }}
                </base-button>
            </div>

        </form>
    </card>
</template>

<script>
    export default {

        data() {
            return {
                loader: this.$xapi.loaders.logs,
                filters: this.$xapi.filters.logs,
            }
        },

        created() {
            this.$xapi.filters.logs.attach(this)
        },

        methods: {

            apply() {
                this.loader.firstLoad()
            },

            reset() {
                this.filters.reset()
                this.loader.firstLoad()
            }
        }
    }
</script>
